import React from "react";
import chart from "../images/chart.jpg";
import chart2 from "../images/chart-2.jpg";
import declaration from "../images/declaration.jpg";
const IR330CFooter = () => {
  return (
    <div className="row">
      <div className="container">
        <div className="page2" style={{ marginRight: "-29px", boxShadow: "1px 1px 1px 1px #fff" }}>
          <img src={chart} alt="ird tax code chart" />
        </div>
        <div className="pagebreak" />
        <div className="page2" style={{ marginLeft: "-30px", boxShadow: "1px 1px 1px 1px #fff" }}>
          <img src={chart2} alt="ird tax code chart2"/>
        </div>

        <div className="pagebreak" />
        <div className="page2" style={{ boxShadow: "1px 1px 1px 1px #fff" }}>
          <img src={declaration} alt="ird tax code info" />
        </div>
        {/* <div className="row ">
          <div className="container">
            <div className="tcd-form-details-bottom">
              <div className="once-completed-box top-pink-title-box mb-0 fontsize-16" style={{ padding: "25px 25px 20px", borderRadius: "25px 25px 25px 0" }}>
                <div className="box-inline-data">
                  <div className="details fontsize-16 pb-0">
                    <p className="mb-0">
                      <strong>Important: You may need to change your tax code if your circumstances change during the year. For example:</strong>
                    </p>
                  </div>
                </div>

                <div className="box-inline-data">
                  <div className="title fontsize-16 pb-0">
                    <strong>–</strong>{" "}
                  </div>
                  <div className="details fontsize-16 pb-0">
                    <p className="mb-0">
                      <strong>you take out a student loan or pay it off</strong>
                    </p>
                  </div>
                </div>

                <div className="box-inline-data">
                  <div className="title fontsize-16 pb-0">
                    <strong>–</strong>{" "}
                  </div>
                  <div className="details fontsize-16 pb-0">
                    <p className="mb-0">
                      <strong>start or stop being eligible to use ME or ME SL (see note 5 below)</strong>
                    </p>
                  </div>
                </div>

                <div className="box-inline-data">
                  <div className="title fontsize-16 pb-0">
                    <strong>–</strong>{" "}
                  </div>
                  <div className="details fontsize-16 pb-0">
                    <p className="mb-0">
                      <strong>you have a second job and your income decreases or increases, changing the code you should be using.</strong>
                    </p>
                  </div>
                </div>
              </div>
              {/* <!--top-pink-title-box end--> */}

              {/*<div className="help-note ">
                <div className="row">
                  <div className="col-md-12 col-sm-12 col-lg-12">
                    <p className="mb-1 title">
                      <strong>Notes to help you complete this for</strong>
                    </p>
                  </div>
                </div>
              </div>
              {/* <!--bottom-darkpink-title-box end--> */}

              {/*<div className="tcd-innerdetails pb-3" style={{ borderRadius: "10px 0 15px 15px" }}>
                <div className="row">
                  <div className="col-md-12 col-sm-12 col-lg-12 fontsize-16">
                    <p className="mb-0">
                      1. If you receive a <strong>benefit from Work and Income</strong> (other than a student allowance, NZ Super or Veteran’s Pension) you must use the <strong>“M”</strong> tax code for this income. <strong />
                      <strong>You must use the secondary income section on page 3 to work out your tax code for any other taxable income.</strong>
                    </p>
                    <p>
                      If you choose a secondary tax code of <strong>“S”</strong> or <strong>“S SL”</strong> and you’ll earn more from your secondary job than your benefit, you may pay more tax than you’re required = {true} to for that job. You can
                      apply for <strong>a tailored tax code</strong> so that the right amount of tax is deducted - see note 9 for more information about tailored tax codes.
                    </p>

                    <p>
                      2. Annual PAYE income payments means income such as salary, wages, weekly accident compensation payments, NZ Super, Veteran’s weekly compensation, Veteran’s Pension, student allowance and schedular payments, earned from 1 April to 31 March. Salary and
                      wages means the same but excludes schedular payments.
                    </p>

                    <p>3. You are a New Zealand tax resident in any of these situations:</p>
                    <ul className="pl-3 mb-1">
                      <li className="pl-2">You’ve been in New Zealand for more than 183 days in any 12-month period and haven’t become a non-resident.</li>
                      <li className="pl-2">You have a permanent place of abode in New Zealand.</li>
                      <li className="pl-2">You’re away from New Zealand in the service of the New Zealand Government.</li>
                    </ul>
                    <p>
                      4. Your <strong>annual net income</strong> is your total income (before tax is deducted) from all sources less your allowable deductions, from 1 April to 31 March. It excludes a loss carried forward or back from a previous or future year.
                    </p>
                    <p>
                      5. If you or your partner are entitled to receive Working for Families Tax Credits (WfFTC) or an overseas equivalent, or if you receive an income-tested benefit, NZ Super, Veteran’s Pension or an overseas equivalent of any of these, your tax code is “M”
                      (or “M SL” if you have a student loan). You’re not eligible to use “ME” or “ME SL”.<br/>For more information about WfFTC go to <strong>ird.govt.nz/wfftc </strong>
                    </p>

                    <p className="mb-0">
                      6. You may be eligible for a repayment deduction exemption on your salary and wage income if you:</p>
                      <ul className="pl-3 mb-1">
                        <li className="pl-2">have a student loan</li>
                        <li className="pl-2">are studying full-time in New Zealand</li>
                        <li className="pl-2">expect to earn below the annual repayment threshold from all sources</li>
                        <li className="pl-2">earn above the pay-period repayment threshold.</li>
                      </ul>

                    <p className="mb-0">
                      If you have a student loan and you choose <strong>“SB SL”</strong> or <strong>“S SL”</strong> for your tax code, you may pay more towards your student loan than you need to. If you earn under the pay period repayment threshold
                      from your main job, you can apply for a special deduction rate to reduce your student loan repayment deductions on your secondary earnings.
                    </p>
                    <p>
                      For more information about repayment deduction exemptions and special deduction rates go to <strong>ird.govt.nz/studentloans</strong> If you already have a repayment deduction exemption or special deduction rate for your
                      student loan but your circumstances have changed, you’ll need to update your details so we can check you’re still eligible. You can do this at <strong>www.ird.govt.nz</strong> or by calling 0800 227 774.
                    </p>

                    <p>
                      7. <strong>Casual agricultural workers</strong> are people engaged in casual seasonal work on a day-to-day basis, for up to three months. This includes shearers and shearing shed-hands.
                    </p>
                    <p>
                      8. <strong>Election day workers</strong> are people working for the elections for the period of advanced voting and election day only.
                    </p>
                    <p>
                      9. If you are a recognised seasonal worker or hold a work visa as foreign crew of a vessel fishing New Zealand waters, you will use the <strong>“NSW”</strong> code. <strong>Recognised seasonal workers</strong> must be employed
                      by a registered employer under the Recognised Seasonal Employers’ Scheme and are employed in the horticulture or viticulture industries. You must have a Recognised Seasonal Employer Limited Visa/Permit. See{" "}
                      <strong>www.immigration.govt.nz</strong> (search keyword: seasonal).
                    </p>

                    <p className="mb-0">10. If you have a current <strong>tailored tax code</strong> certificate, enter <strong>“STC”</strong> as your tax code on page 1 and show your original tailored tax code certificate to your employer.</p>
                    <p>
                      A tailored tax code is a tax deduction rate worked out to suit your individual circumstances. You may want one if the regular tax codes will result in you not paying enough tax or paying too much. For more information go to{" "}
                      <strong>ird.govt.nz</strong> or contact us on <strong>0800 227 774.</strong> You can apply for a tailored tax code in myIR or download a <strong> Tailored tax code application IR23BS </strong>form at <strong>ird.govt.nz</strong>.
                    </p>

                    <p>
                      11. <strong>If you need help choosing your tax code go to ird.govt.nz or contact us on 0800 227 774.</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default IR330CFooter;
